import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllPurchaseOrderLinesView } from "src/components/views/erp/purchase/purchaseOrders/AllPurchaseOrderLinesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/purchase/allPurchaseOrderLines")({
	staticData: { title: i18n.t("all_purchase_order_lines"), legacyViewKey: "allPurchaseOrderLinesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllPurchaseOrderLinesView />;
}
